"use client";

import Image from "next/image";
import { IoIosArrowDropright } from "react-icons/io";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { Badge } from "../ui/badge";
import Film from "./benefitsData";
import { useState } from "react";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { Card } from "../ui/card";
import useBenefits from "./benefitsData";
// Accept benefits as a prop
interface SingleBenefitsSectionProps {
  benefits: ReturnType<typeof useBenefits>;
}

const SingleBenefitsSection: React.FC<SingleBenefitsSectionProps> = ({
  benefits,
}) => {
  // Determine columns based on number of cards
  let gridCols = "grid-cols-1";
  if (benefits.length === 2) {
    gridCols = "md:grid-cols-2";
  } else if (benefits.length >= 3) {
    gridCols = "md:grid-cols-2 lg:grid-cols-3";
  }

  return (
    <div className={`grid ${gridCols} gap-6 sm:gap-8 lg:gap-10 benefits`}>
      {benefits.map((benefits) => (
        <Link href={benefits.action} key={benefits.id}>
          <Card
            className={`relative rounded-tl-[40px] rounded-br-[40px] border-0 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group bg-gradient-to-br ${benefits.bgGradient} h-[220px] sm:h-[320px] md:h-[220px] w-auto`}
          >
            {/* Content */}
            <div className="relative z-10 p-6 sm:p-8 h-full flex flex-col justify-between">
              <div className="visible group-hover:hidden flex flex-row justify-between min-h-0">
                <img
                  src={benefits.image.src}
                  alt={benefits.image.alt}
                  loading="lazy"
                  style={{
                    width: benefits.image.width ? benefits.image.width : "35%",
                  }}
                  className="mt-4 absolute bottom-0 group-hover:hidden left-0 h-auto object-cover"
                />
                <div
                  className={` ${benefits.textColor} leading-tight mb-3 sm:mb-4 relative left-[50%]  md:left-[50%] top-[35%] benifits`}
                >
                  <h4 className="text-2xl sm:text-3xl md:text-2xl font-bold">
                    {benefits.title}
                  </h4>
                  <h2 className="benifit text-[min(10vw,30px)] font-bold text-white leading-tight mb-3 sm:mb-4">
                    {benefits.sub}
                  </h2>
                </div>
              </div>

              {/* Hover Content */}
              <div className="hidden group-hover:block">
                <h3
                  className={`text-2xl sm:text-3xl md:text-3xl font-bold ${benefits.textColor} leading-tight mb-3 sm:mb-4`}
                >
                  {benefits.hoverTitle}
                </h3>
                <p
                  className={`text-sm sm:text-base md:text-md ${benefits.textColor} opacity-90 max-w-xs`}
                >
                  {benefits.description}
                </p>
              </div>

              {/* Arrow Button */}
              <div className="flex justify-end absolute bottom-3 right-5">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110">
                  <IoIosArrowDropright
                    className={`w-6 h-6 sm:w-7 sm:h-7 ${benefits.textColor} group-hover:translate-x-0.5 transition-transform duration-300`}
                  />
                </div>
              </div>
              {/* Arrow Button */}
            </div>

            {/* Hover Effect Overlay */}
            <div className="absolute inset-0 rounded-tl-[40px] rounded-br-[40px] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export default SingleBenefitsSection;
